import { DataTableHeaderComponent } from './table/datatable-header.component';
import {
    Component, OnInit, ViewChild, ElementRef, OnChanges, Input, SimpleChanges, ContentChild, TemplateRef,
    QueryList, AfterContentInit, AfterViewInit, ContentChildren, Output, EventEmitter, ViewEncapsulation, OnDestroy
} from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { DataTableColumn } from './datatable-column';
import { FarrisTableColumnDirective } from './datatable-column.component';
import { DataTableService } from './datatable.service';
import { DataTableBodyComponent } from './table/datatable-body.component';
import { Subscription } from 'rxjs';
import { IdService } from './utils/id.service';
import { sortData } from './utils/sort';
@Component({
    selector: 'farris-table',
    templateUrl: './datatable.component.html',
    styleUrls: ['./datatable.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DataTableComponent implements OnInit, OnChanges, OnDestroy, AfterContentInit, AfterViewInit {

    // å¤é  åé
    @Input() singleSelect = true;

    /* æ°æ®æ è¯ */
    @Input() idField = 'id';

    /* é¼ æ æ¬åé«äº® */
    @Input() hover: boolean;

    /* è¡æé©¬çº¿æ ·å¼ */
    @Input() striped: boolean;

    /* è¡¨æ ¼è¾¹æ¡ */
    @Input() bordered: boolean;

    /* è¡¨æ ¼å¤§å° ç´§å¯åè¿æ¯çæ¾å*/
    @Input() size = 'small';

    /* æ¯ææ·»å è¡ ååæ ¼ ç±»æ ·å¼ */
    @Input() rowClassName: (row: any, index: number) => string;
    @Input() cellClassName: (value: any, col: any) => string;

    /*åæ¯ææåº */
    @Input() sortType: 'single' | 'multiple';
    @Input() sortable: boolean;
    @Input() sortSetting: any[];

    /* æ¯å¦æ¾ç¤ºè¡å· */
    @Input() showLineNumber: boolean;

    /* ç©ºæ°æ®æç¤º */
    @Input()
    @ContentChild('noDataText') noDataText: TemplateRef<any>;

    // åæ¯å¦æ¯æresize
    @Input() resizable: boolean;

    // table å®½é«
    @Input() width: number;
    @Input() height: number;

    // å ä¿¡æ¯
    @Input() columns: DataTableColumn[];

    // æ°æ®
    @Input() data: any[];


    /* æåºå¹¿æ­äºä»¶ */
    @Output() sortChange: EventEmitter<any> = new EventEmitter<any>();

    /* è¡¨å¤´dom */
    @ViewChild('dtHeader', { read: ElementRef }) dtHeader: ElementRef;

    /* è¡¨ä½ */
    @ViewChild('dtBody') dtBody: DataTableBodyComponent;

    /* è¡¨æ ¼åæåæ¨¡æ¿ */
    @ContentChildren(FarrisTableColumnDirective) columnsRef: QueryList<FarrisTableColumnDirective>;

    /* åå§æ°æ® */
    originData: any;

    // è¡¨æ ¼å¯ææ½å®½åº¦ç³»å
    // ææ½çº¿
    // æ¯å¦å¯ææ½  é»è®¤å¯ä»¥
    movable: boolean;
    // ç¨æ·è·åè¡¨å¤´+è¡¨æ ¼åå®¹çé«åº¦  å®½åº¦  ç­
    datatableContainer: HTMLDivElement;

    // ææ½çº¿åå§åä½ç½®
    startX: number;

    // å½åå¯è°æ´åçç´¢å¼
    resizeColIndex: number;

    /* å½ååå®½åº¦ */
    resizeThWidth: number;

    /* è¡¨å¤´å®½åº¦ */
    tableHeaderX: number;

    // äºä»¶è®¢éå­å¨  ä¾¿äºéæ¯
    subscription: Subscription[] = [];

    currentRowIndex: number;
    currentRow: any;

    get selections() {
        return this.dtBody.selections;
    }

    constructor(private dataService: DataTableService, private el: ElementRef, private idService: IdService) {

        /* åéå¤é */
        this.dataService.selectedRow.subscribe((e: any) => {
            if (this.singleSelect) {
                this.currentRowIndex = e.rowIndex;
                this.currentRow = e.rowData;
            } else {
                if (this.selections) {
                    this.dtBody.isCheckAll = Object.keys(this.selections).length === this.data.length;
                }
            }
        });

        this.dataService.unSelectedRow.subscribe((e: any) => {
            if (this.singleSelect) {
                this.currentRow = undefined;
                this.currentRowIndex = -1;
            } else {
                this.dtBody.isCheckAll = false;
            }
        });
    }

    ngOnInit() {
        // åå§åæåº æ·±æ·è´æ°æ®
        this.originData = JSON.parse(JSON.stringify(this.data));

    }

    private setSortDirection() {
        this.columns.forEach(ele => {
            ele['direction'] = undefined;
        });
    }
    // æåºäºä»¶ è®¾ç½®ä¸ä¸ä¸ªæåºç¶æ æ´é²åºAPI å½ååæ è¯ä»¥åä¸ä¸ä¸ªæåºç¶æ
    sortData(event: MouseEvent, column: any) {
        event.stopPropagation();
        if (!this.sortable || !column.sortable) {
            return;
        }
        const sortInfo = sortData(this.originData, this.data, column);
        this.data = sortInfo.data;
        this.setSortDirection();
        // æåºå¾æ 
        column.direction = sortInfo.dir;
        // éç½®ææåçæåºæ¹å
        this.sortChange.emit([{
            field: column.field,
            dir: sortInfo.dir
        }]);

    }

    ngOnChanges(changes: SimpleChanges) {
    }

    ngAfterContentInit() {
        // æ¯æåç»ä»¶åå¥
        if (!this.columns) {
            if (this.columnsRef && this.columnsRef.length) {
                this.columns = [];
                this.columnsRef.forEach((col: any) => {
                    this.columns.push(col);
                });
            }
        }
    }
    ngAfterViewInit() {

        // åå§åæåº  åå§åæ°æ®æåº
        this.setSortDirection();
        // è·åè¡¨æ ¼å®¹å¨  å³è¡¨æ ¼
        // è·åæ´ä½table
        this.datatableContainer = this.el.nativeElement.querySelector('.farris-table');

    }
    ngOnDestroy() {
    }

    /**
     * è·åè¡¨æ ¼å®¹å¨çä½ç½®  è·ç¦»å·¦è¾¹è§å£åä¸è¾¹è§å£çè·ç¦»  å¦æé¡µé¢ææ»å¨æ¡  éè¦å ä¸æ»å¨æ¡æ»å¨çæ°å¼
     */
    getContainerOffset() {
        const rect = this.datatableContainer.getBoundingClientRect();
        return {
            left: rect.left + document.body.scrollLeft,
            top: rect.top + document.body.scrollTop,
            right: rect.right,
            bottom: rect.bottom,
        };
    }

    /* é¼ æ æä¸ä¼¸ç¼©åå¼æåç´  */
    beginDrag(e: any, ele: HTMLSpanElement) {
        e.preventDefault();
        e.stopPropagation();
        // é¼ æ ç¹å» åå§åä½ç½®
        const tableHeader = this.dtHeader.nativeElement.querySelector('.table');
        const resizeHandlers = this.dtHeader.nativeElement.querySelectorAll('.column-resize-handler');
        const resizeHandlersParent = ele.parentElement;
        this.startX = e.pageX;
        this.tableHeaderX = tableHeader.clientWidth;
        this.resizeThWidth = resizeHandlersParent.offsetWidth;

        for (const i in resizeHandlers) {
            if (resizeHandlers[i] === ele) {
                this.resizeColIndex = Number(i);
            }
        }
        this.movable = true;
    }

    /* é¼ æ ç§»å¨ä¼¸ç¼©åå¼æåç´  */
    moveDrag(e, el) {
        e.stopPropagation();
        if (this.movable) {
            const ths = this.dtHeader.nativeElement.querySelectorAll('th');
            const trs = this.dtBody.el.nativeElement.querySelectorAll('tr');
            const tableHeader = this.dtHeader.nativeElement.querySelector('.table');
            const tableBody = this.dtBody.el.nativeElement.querySelector('.table');
            ths[this.resizeColIndex].style.width = this.resizeThWidth + (e.pageX - this.startX) + 'px';
            for (const tr of trs) {
                const tds = tr.querySelectorAll('td');
                tds[this.resizeColIndex].style.width = this.resizeThWidth + (e.pageX - this.startX) + 'px';
            }
            this.columns[this.resizeColIndex].width = this.resizeThWidth + (e.pageX - this.startX);
            tableHeader.style.width = this.tableHeaderX + (e.pageX - this.startX) + 'px';
            tableBody.style.width = this.tableHeaderX + (e.pageX - this.startX) + 'px';
        }
        // el.style.width = '10px';
        // el.style.position = 'absolute';
        // el.style.right = '0px';
        // this.dragLine.nativeElement.style.left = (e.pageX - containerLeft) + 'px';
        // é¼ æ ç§»å¨  è®¾ç½®ææ½çº¿æ»æ¯å¯è§
        // this.dragLine.nativeElement.style.display = 'block';
    }

    /* é¼ æ æ¬èµ·ä¼¸ç¼©åå¼æåç´  */
    stopDrag(e, column) {
        this.movable = false;
        const tableHeader = this.dtHeader.nativeElement.querySelector('.table');
        // const tableBody = this.dtBody.el.nativeElement.querySelector('.table');
        // tableHeader.style.width = this.tableHeaderX + (e.pageX - this.startX) + 'px';
        // tableBody.style.width = this.tableHeaderX + (e.pageX - this.startX) + 'px';

        console.log(tableHeader.clientWidth - this.tableHeaderX);
    }
    resizeColumn(e, column) {
        // // åç§»é
        // ææ½ååå®½
        // const columnWidth = column.offsetWidth;
        // // ææ½ååå®½
        // // const newColumnWidth = columnWidth + delta;
        // // æå°å®½åº¦
        // const minWidth = column.style.minWidth || 15;
        // // è®¾ç½®å¤´é¨æå¨åå®½åº¦
        // column.style.width = newColumnWidth + 'px';
        // // è®¾ç½®è¡¨ä½æå¨åå®½åº¦
        // const headerCells = this.dtHeader.nativeElement.querySelectorAll('th');
        // let cellIndex;
        // for (const i in headerCells) {
        //     if (headerCells[i] === column) {
        //         cellIndex = i;
        //     }
        // }
        // // const cellIndex = headerCells.findIndex((ele: any) => {
        // //     return ele === column;
        // // });
        // const bodyCells = this.dtBody.el.nativeElement.querySelectorAll('td');
        // bodyCells[cellIndex].style.width = newColumnWidth + 'px';
        // col.style.width = newColumnWidth + 'px';
        // æ°å®½åº¦å¤§äºæå°å®½åº¦æ¶  éæ°è®¾ç½®å®½åº¦
        // if (newColumnWidth > parseInt(minWidth, 10)) {
        //     let colIndex = -1;
        // const cols = this.dtHeader.nativeElement.querySelectorAll('th');
        // for (let i = 0; i < cols.length; i++) {
        //     if (cols[i] === column) {
        //         colIndex = i;
        //     }
        // }
        //     // è®¾ç½®åä¸ä¸ªååæ ¼å®½åº¦
        //     const nextColumn = column.nextElementSibling;
        //     if (nextColumn) {
        //         // ä¸ä¸ä¸ªååæ ¼çææ°å®½åº¦
        //         const nextColumnWidth = nextColumn.offsetWidth - delta;
        //         const nextColumnMinWidth = nextColumn.style.minWidth || 15;
        //         if (newColumnWidth > 15 && nextColumnWidth > parseInt(nextColumnMinWidth, 10)) {
        //             this.resizeColGroup(this.dtHeader.nativeElement, colIndex, newColumnWidth, nextColumnWidth);
        //             this.resizeColGroup(this.dtBody.el.nativeElement, colIndex, newColumnWidth, nextColumnWidth);
        //         }
        //     }
        // }
        // è®¡ç®å®½åº¦å®æ¯  è®¾ç½®ææ½çº¿éè
    }
    onScrollX(e: any) {
        // æ¨ªåæ»å¨ éåºå®è¡¨å¤´æ»å¨
        const x = e.srcElement.scrollLeft;
        // this.tableHeader.nativeElement.scrollTo(x, 0);
    }
    /**
     * æ»å¨æ¡çºµåæ»å¨
     */
    onScrollY(e: any) {
        const y = e.srcElement.scrollTop;
        // this.dtLeftFixed.nativeElement.style.top = -y + 'px';
        // this.dtRightFixed.nativeElement.style.top = -y + 'px';

    }
    onCheckAll(state: boolean) {
        this.dataService.selectedAll.next(state);
    }
}

